import { ActionTypesFactory } from "../../utils";

// Action types
export const Disputes = ActionTypesFactory("Disputes", "Disputes");
export const CreateDisputes = ActionTypesFactory("Disputes", "CreateDisputes");
export const ShowDisputes = ActionTypesFactory("Disputes", "ShowDispute");
export const UpdateDisputes = ActionTypesFactory("Disputes", "UpdateDisputes");
export const DisputeComments = ActionTypesFactory(
  "Disputes",
  "DisputeComments"
);

export const CreateDisputeComments = ActionTypesFactory(
  "Disputes",
  "CreateDisputeComments"
);

// Action creators
export const getDisputes = (payload) => {
  return {
    type: Disputes.REQUEST,
    payload,
  };
};

export const createDispute = (payload) => {
  return {
    type: CreateDisputes.REQUEST,
    payload,
  };
};

export const showDispute = (payload) => {
  return {
    type: ShowDisputes.REQUEST,
    payload,
  };
};

export const updateDisputes = (payload) => {
  return {
    type: UpdateDisputes.REQUEST,
    payload,
  };
};

export const getDisputeComments = (payload) => {
  return {
    type: DisputeComments.REQUEST,
    payload,
  };
};

export const createDisputeComment = (payload) => {
  return {
    type: CreateDisputeComments.REQUEST,
    payload,
  };
};
